import gql from "graphql-tag";

export const GET_USER = gql`
    query GetUser($username: String!) {
        users (username: $username) {
            edges{
                node{
                    id
                    username
                    email
                    dateJoined
                    profile {
                        id
                        displayName
                        sex
                        location
                        profession
                        workplace
                        biography
                        websiteUrl
                        twitterLink
                        facebookLink
                        birthday
                        phoneNumber
                        avatarUrl
                    }
                    tagFavoriteSet {
                        edges {
                            node {
                                id
                                name
                                usageCount
                            }
                        }
                    }
                    postSet {
                        edges {
                            node {
                                id
                                subject
                                category
                                message
                                created
                                imagesUrls
                                documentsUrls
                                author{
                                    id
                                    username
                                    profile{
                                        id
                                        displayName
                                    }
                                }
                                tagSet{
                                    edges{
                                        node{
                                            id
                                        }
                                    }
                                }
                                commentSet{
                                    edges{
                                        node{
                                            id
                                        }
                                    }
                                }
                            }
                        }
                    }
                    postPinnedSet {
                        edges {
                            node {
                                id
                                subject
                                category
                                message
                                created
                                imagesUrls
                                documentsUrls
                                author{
                                    id
                                    username
                                    profile{
                                        id
                                        displayName
                                    }
                                }
                                tagSet{
                                    edges{
                                        node{
                                            id
                                        }
                                    }
                                }
                                commentSet{
                                    edges{
                                        node{
                                            id
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
